export default __webpack_public_path__ + "static/O0112-2da0638b746f36597b98cc1b1042f5a5.png";